import { Link, useLocation } from 'react-router-dom';

export default function Tabs({ tabs }) {
    const { pathname } = useLocation();
    return (
       <ul className="nav nav-tabs">
        {tabs.map((tab) => (
            <li key={tab.link} className={`nav-item ${pathname === tab.link ? 'active' : ''}`}>
                <Link to={tab.link}>{tab.name}</Link>
            </li>
        ))}
        </ul>
    );
};

